'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TiChevronRightOutline = function TiChevronRightOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm16.7 33.3c-1.4 0-2.6-0.5-3.6-1.4-0.9-1-1.4-2.2-1.4-3.6s0.5-2.6 1.4-3.5l4.8-4.8-4.8-4.8c-0.9-0.9-1.4-2.2-1.4-3.5s0.5-2.6 1.4-3.6c1.9-1.9 5.2-1.9 7.1 0l11.9 11.9-11.9 11.9c-0.9 0.9-2.2 1.4-3.5 1.4z m0-23.3c-0.5 0-0.9 0.2-1.2 0.5-0.3 0.3-0.5 0.7-0.5 1.2s0.2 0.8 0.5 1.1l7.1 7.2-7.1 7.2c-0.3 0.3-0.5 0.7-0.5 1.1s0.2 0.9 0.5 1.2c0.6 0.6 1.7 0.6 2.3 0l9.6-9.5-9.6-9.5c-0.3-0.3-0.7-0.5-1.1-0.5z' })
        )
    );
};

exports.default = TiChevronRightOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/ti/chevron-right-outline.js
// module id = 3554
// module chunks = 0